<template>
  <b-container fluid class="no-sided-margin">
    <div style="padding-top: 10px">
      <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
        Visualizza i Dispositivi e la loro allocazione. Permette di censire un nuovo dispositivo, di localizzarlo sulla mappa e di modificarne l'allocazione.
      </b-alert>
    </div>
    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="2">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Filtri</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form inline>
              <b-form-checkbox class="ml-2" v-model="checkedSearchInStock" switch @change="inStockTablets()">
                <label class="mr-2"><strong>Tablet Disponibili</strong></label>
              </b-form-checkbox>
            </b-form>
          </b-card-body>
        </b-card>
        <b-card class="margin-top-md" header-bg-variant="light">
          <b-card-body style="padding: 0.5rem">
            <b-form-row>
              <b-form-group class="col-lg-12 col-md-12">
                <b-button-group>
                  <b-button disabled>
                    <b-icon-search/>
                  </b-button>
                  <b-form-input
                    @update="searchDevice"
                    placeholder="cerca">
                  </b-form-input>
                </b-button-group>
                <p></p>
              </b-form-group>
              <b-button block title="Mostra Mappa" v-b-tooltip.hover variant="primary" v-b-modal.show-map>
                <b-icon-map/>&nbsp;Mostra Mappa
              </b-button>
              <b-button block title="Aggiungi Dispositivo" v-b-tooltip.hover variant="primary" v-b-modal.device>
                <b-icon-plus/>
                Aggiungi Dispositivo
              </b-button>
              <b-button @click="exportCsv" :disabled="isDownloading" variant="success" block>
                <b-spinner small v-show="isDownloading"></b-spinner>
                <b-icon-arrow-bar-down/>&nbsp;Download csv
              </b-button>
            </b-form-row>

          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="10">
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-card-checklist/>&nbsp;Dispositivi trovati</strong></span>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="fields"
                     :items="searchedDevices" sort-by="ordinal_number">
              <template #cell(model)="data">
                <img id="tablet-2" v-if="data.item.model && data.item.model === 'SamsungGalaxyTabActive2'"
                     src='@/assets/tablet2.png' alt="SAMSUNG TAB ACTIVE 2" title="SAMSUNG TAB ACTIVE 2">
                <img id="tablet-3" v-if="data.item.model && data.item.model === 'SamsungGalaxyTabActive3'"
                     src='@/assets/tablet3.png' alt="SAMSUNG TAB ACTIVE 3" title="SAMSUNG TAB ACTIVE 3">
              </template>
              <template #cell(tags)="data">
                <div class="text-center">
                  <b-badge v-show="data.item.isMdm" pill variant="info" class="mr-1">MDM</b-badge>
                  <br v-if="data.item.isMdm && (isMisplaced(data.item) || isNotUpdated(data.item) || versionNotPresent())">
                  <b-badge v-show="isMisplaced(data.item)" pill variant="danger">Fuori Posizione</b-badge>
                  <br v-if="isMisplaced(data.item) && (isNotUpdated(data.item) || isUpdated(data.item) || versionNotPresent())">
                  <b-badge v-show="isNotUpdated(data.item) " pill variant="warning">Non Aggiornato</b-badge>
                  <b-badge v-show="versionNotPresent()" pill variant="warning">Errore Versione</b-badge>
                </div>
              </template>
              <template #cell(activatedAt)="data">
                {{ asISODate(data.item.activatedAt) }}
              </template>

              <template #cell(actions)="data">
                <b-button-group class="mr-2">
                  <b-button size="sm" title="Modifica il negozio" v-b-tooltip.hover variant="success"
                            v-b-modal.move-device @click="modalDevice(data.item)">
                    <b-iconstack>
                      <b-icon stacked icon="file"></b-icon>
                      <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
                    </b-iconstack>
                  </b-button>
                  <b-button variant="info" v-show="data.item.lastPosition !== null" size="sm"
                            @click="data.toggleDetails">
                    <b-icon v-bind:icon="data.detailsShowing ? 'pin-map-fill' : 'pin-map'" aria-hidden="true"></b-icon>
                  </b-button>
                </b-button-group>
              </template>
              <template #row-details="data">
                <div class="mt-3">
                  <div class="single-map">
                    <Map :devices="[data.item]" :zoom="16"/>
                  </div>
                </div>
              </template>

            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal centered id="move-device" title="Spostamento Tablet" @ok="moveDevice" @cancel="initDevice()" hide-header-close
             no-close-on-backdrop>
      <p>Spostamento del dispositivo numero <strong>{{ deviceSelected.ordinalNumber }}</strong></p>
      <p>da <strong>{{ deviceSelected.shop }}</strong></p>
      <p>a</p>
      <b-form-group label="Filiale">
        <ShopSelect v-model="shopUpdated" :required="false" description="Filiale"/>
      </b-form-group>
      <hr>
      <div class="mb-2">
        <span class="text-muted" style="font-size: 0.9rem;">Configurazione MDM</span>
      </div>
      <b-form-checkbox v-model="mdmUpdateValue">
        MDM Abilitato
      </b-form-checkbox>
    </b-modal>

    <b-modal size="xl" id="show-map" title="Mappa dei dispositivi" hide-header-close no-close-on-backdrop>
      <div class="general-map">
        <Map :devices="devices" :zoom="12"/>
      </div>
    </b-modal>

    <Device :ordinal-number="lastOrdinalNumber()" event-name="device-added" @device-added="addDevice"/>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
    </div>
  </b-container>
</template>

<script>
import Tablets from "@/api/TabletsApi";
import ShopSelect from '../components/ShopSelect';
import Map from '../components/devices/Map.vue'
import Device from "../components/devices/Device.vue";
import moment from "moment/moment";
import MiniSearch from "minisearch";
import eventBus from "@/EventBus";

let miniSearch = new MiniSearch({
  fields: ['ordinalNumber', 'shop', 'serialNumber'],
  storeFields: ['ordinalNumber', 'model', 'shop', 'serialNumber', 'imei', 'pin', 'macAddress', 'activatedAt', 'latitude', 'longitude', 'locatedAt', 'misplaced', 'isMdm', 'appVersion'],
  searchOptions: {
    prefix: true
  }
})


export default {
  name: 'Devices',
  components: {ShopSelect, Map, Device},
  provide() {
    return {parentValidator: this.$validator}
  },
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
    this.getVersion().then(() => {
      this.findTablets()
    })
  },

  data: () => ({
    showAlert: false,
    lastVersion: '',
    fields: [
      {key: "ordinalNumber", label: "#"},
      {key: "model", label: "Modello"},
      {key: "shop", label: "Negozio"},
      {key: "serialNumber", label: "Numero Seriale"},
      {key: "imei", label: "IMEI"},
      {key: "pin", label: "Pin di Sblocco"},
      {key: "macAddress", label: "MAC"},
      {key: "activatedAt", label: "Data Attivazione"},
      {key: "tags", label: ''},
      {key: "actions", label: ''}
    ],
    devices: [],
    searchedDevices: [],
    shops: [],
    deviceSelected: {},
    shopUpdated: {},
    mdmUpdateValue: false,
    isDownloadingStats: false,
    checkedSearchInStock: false
  }),
  methods: {
    findTablets() {
      Tablets.findAll().then(devices => this.fillDevices(devices))
    },
    inStockTablets() {
      if (this.checkedSearchInStock) {
        Tablets.findInStock().then(devices => this.fillDevices(devices))
      } else this.findTablets()
    },
    fillDevices(devices) {
      miniSearch.removeAll()
      this.devices = devices
      this.searchedDevices = this.devices.map(device => ({
        id: device.ordinalNumber,
        ...device
      }))

      miniSearch.addAll(this.searchedDevices)
    },
    modalDevice(device) {
      this.deviceSelected = device
      this.mdmUpdateValue = device.isMdm
    },
    getVersion() {
      return Tablets.getLastVersion()
        .then(data => this.lastVersion = data.version)
    },
    versionNotPresent(){
      return this.lastVersion=== ''
    },
    makeConfirmationModal() {
      const h = this.$createElement
      let destinationText = 'Invariata'; // Default se vuoto
      if (this.shopUpdated && this.shopUpdated.id) {
        destinationText = `${this.shopUpdated.code} - ${this.shopUpdated.name}`;
      }
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('p', [
          'Confermi di voler spostare il dispositivo ',
          h('strong', this.deviceSelected.ordinalNumber),
        ]),
        h('p', [
          'da ',
          h('strong', this.deviceSelected.shop)
        ]),
        h('p', [
          'a ',
          h('strong', destinationText)
        ]),
        h('p', [
          'Stato MDM: ',
          h('strong', this.mdmUpdateValue ? 'Abilitato' : 'Disabilitato')
        ])
      ])
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: 'Conferma spostamento dispositivo',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        headerCloseVariant: 'light',
        okVariant: 'success',
        okTitle: 'Conferma',
        cancelTitle: 'Annulla',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true
      })
    },
    moveDevice(event) {
      event.preventDefault()

      this.$validator.validateAll().then(result => {
        if (result) {
          this.makeConfirmationModal()
            .then(agreed => { if (agreed) {
              const shopIdToSend = (this.shopUpdated && this.shopUpdated.id) ? this.shopUpdated.id : undefined;
              return Tablets.setShop(
                this.deviceSelected.serialNumber,
                shopIdToSend,
                this.mdmUpdateValue
              )
            }})
            .then(() => this.makeToast('success', 'Spostamento del dispositivo eseguita correttamente'))
            .catch(() => this.makeToast('danger', 'Spostamento del dispositivo non riuscita!'))
            .finally(() => this.initDevice())
            .then(() => this.checkedSearchInStock = false)
        }
      })
    },
    addDevice(event) {
      Tablets.add(event)
        .then(() => this.makeToast('success', 'Aggiunta dei dati del dispositivo eseguita correttamente'))
        .catch(() => this.makeToast('danger', 'Aggiunta dei dati del dispositivo NON riuscita!'))
        .finally(() => {
          this.$bvModal.hide('device')
          this.findTablets()
        })
    },
    initDevice() {
      this.$bvModal.hide('move-device')
      this.findTablets()
      this.deviceSelected = {}
      this.shopUpdated = {}
      this.mdmUpdateValue = false
      this.checkedSearchInStock = false
    },
    exportCsv() {
      this.isDownloading = true
      Tablets
        .downloadCsv()
        .finally(() => {
          this.isDownloading = false
        })
    },
    searchDevice(text) {
      if (text === '') this.searchedDevices = this.devices
      else {
        this.searchedDevices = miniSearch.search(text)
      }
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        title: 'Negozio',
        variant: type,
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
    isMisplaced(device) {
      return device.misplaced > 2
    },
    lastOrdinalNumber() {
      let numbers = this.devices.map(item => item.ordinalNumber)
      return Math.max(...numbers) + 1
    },
    asISODate: date => moment(date).format('DD/MM/YYYY'),
    isNotUpdated(device) {
      return device.appVersion !== this.lastVersion && this.lastVersion !== ''
    },
    isUpdated (device) {
      return device.appVersion === this.lastVersion && this.lastVersion !== ''
    },
  }
}
</script>

<style>
.general-map {
  width: 100%;
  height: 600px;
}

.single-map {
  width: 100%;
  height: 300px;
}
</style>
